import { render, staticRenderFns } from "./VldScheme.vue?vue&type=template&id=4832c220&scoped=true&"
import script from "./VldScheme.vue?vue&type=script&lang=js&"
export * from "./VldScheme.vue?vue&type=script&lang=js&"
import style0 from "./VldScheme.vue?vue&type=style&index=0&id=4832c220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4832c220",
  null
  
)

export default component.exports